import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "What is React Native?",
    answer: `<p>React Native is an open-source, cross-platform app development framework released in 2015 by Facebook. It's arguably the best cross-platform app development framework (contended by Flutter) trusted by thousands of businesses, including startups and Fortune 100 companies.</p>`,
  },
  {
    question: "What is React used for?",
    answer: ` <p>React Native is used to build native cross-platform mobile apps for iOS and Android using a single codebase. This React Native cross-platform app development capability helps entrepreneurs cut their app development costs in half, reduce turnaround time for full-scale development, and make maintaining the app more accessible.</p>`,
  },
  {
    question: "Why opt for React Native?",
    answer: `<p>React Native is arguably the best cross-platform mobile app development framework for developing iOS and Android apps using a single codebase. It's an open-source project backed by Facebook and trusted by thousands of corporate businesses globally. Exceptional performance, native touch, low development cost, and short turnaround times are why you should choose React Native for app development.</p>`,
  },
  {
    question: "How much does it cost to build a React Native mobile app?",
    answer: `<p>The cost of developing a React Native mobile app can change depending on difficulty, aspects, and layout. TekRevol offers modified quotes after evaluating your requirements. Contact us for a free comprehensive consultation and a tailored estimation for your project requirements.</p>`,
  },
  {
    question: "How do you hire a React Native app development company?",
    answer: ` <p>To hire a React Native app development company, any business, startup, or aspiring individual should adhere to the following steps:</p> 
        <ul>
        <li>Research: Search for companies with experience in React Native.</li>
        <li>Portfolio Evaluation: Check their portfolio for applicable ventures.</li>
        <li>Client Testimonials: Go through client testimonials and analyses.</li>
        <li>Communication: Assess their communication and partnership processes.</li>
        <li>Cost Estimation: Ask for a detailed cost estimate for your app venture.</li>
    </ul>`,
  },
  {
    question: "What technology companies are using React?",
    answer: ` <p>Thousands of industry technology companies and big names are using react native programming in their mobile applications. Popular apps you regularly use, such as Facebook, Instagram, Pinterest, Discord, Skype, and Uber Eats, are all built using the React native app development framework.</p>`,
  },
  {
    question: "How long does it take to develop a React Native app?",
    answer: `<p>It can typically take 2 to 3 months, depending on the client's app's complexity and the required integration features.</p>`,
  },
  {
    question:
      "How does React Native contribute to cost savings in app development?",
    answer: `<p>React Native permits the development of cross-platform mobile apps utilizing a sole codebase, decreasing the requirement for discrete development teams for iOS and Android. This combined method significantly reduces costs, making it a cost-effective choice for app development.</p>`,
  },
  {
    question: "Can existing mobile apps be migrated to React Native?",
    answer: `<p>Existing mobile apps can be transferred to React Native. The framework backs steady migration, allowing the integration of React Native elements into an existing app. This offers a path to utilize the advantages of React Native without beginning from scratch.</p>`,
  },
  {
    question:
      "How does React Native guarantee a smooth user experience across platforms?",
    answer: `<p>React Native compiles native code, warranting near-native performance and a reliable user experience across iOS and Android platforms. Combined with a rich ecosystem of pre-built components, this ability underwrites an effortless and receptive app interface.</p>`,
  },
  {
    question:
      "What constant support and maintenance services does TekRevol offer for React Native apps?",
    answer: `<p>TekRevol provides complete support and maintenance services for React Native apps, guaranteeing unceasing updates, bug fixes, and optimizations. Our hardworking team is dedicated to keeping your app working efficiently and updated with the latest industry standards.</p>`,
  },
  {
    question: "Why choose TekRevol for React native app development?",
    answer: `<p>TekRevol stands out for React Native app development for the following reasons:</p> 
        <ul>
        <li>Expertise: Our skilled developers guarantee high-quality solutions.</li>
        <li>Innovation: We utilize the latest technologies for state-of-the-art apps.</li>
        <li>Transparency: We uphold transparent communication and project visibility.</li>
        <li>Cost-Efficiency: Our pricing models guarantee value for your investment.</li>
        <li>Support: TekRevol offers constant support and maintenance for enduring success.</li>
    </ul>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>React Native App FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
